var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{class:_vm.buttonClasses,attrs:{"disabled":_vm.disabled,"size":_vm.size,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }